import { ForkJoinTask } from './forkJoinTask.types'

export const createForkJoinTask = ({
  name,
  taskReferenceName,
  inputParameters,
  forkTasks
}: Pick<
  ForkJoinTask,
  'name' | 'taskReferenceName' | 'inputParameters' | 'forkTasks'
>): ForkJoinTask => {
  return {
    type: 'FORK_JOIN',
    name,
    taskReferenceName,
    inputParameters,
    forkTasks
  }
}
